// extracted by mini-css-extract-plugin
export default {"dndContainer":"TagsSetupModal__dndContainer___rc0a2"};